import dynamic from 'next/dynamic';
import css from './index.module.scss';
import A from './components/A';
import { useGlobal } from '@/utils/useGlobal';

const PageConPc = dynamic(() => import('@/components/productSmart/wave2/teaser/indexDynamic'), {
    ssr: true,
});

export default function Wave2TeaserPC({ ecoflowflag }: any) {
    const { useRouter, useEffect } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    useEffect(() => {
        if (ecoflowflag) {
            return null;
        }
        // 由于pages下404允许了， cn，jp有详情页、无预热
        if (['jp', 'cn'].includes(locale)) {
            router.push('/404');
        }
    }, []);
    return (
        <div className={`wave2-teaser-pc ${css.wave2TeaserPC}`}>
            <A />
            <PageConPc />
            {/* 预热站点不展示导航栏 & popup css */}
            <style jsx global>
                {`
                    .product_naver .detail-nav {
                        display: none !important;
                    }
                    .ant-modal-root .ef-popup {
                        .ant-modal-close {
                            left: unset;
                            right: 30px;
                            top: 30px;
                        }
                        .ant-modal-body {
                            .popup-title {
                                font-family: var(--font-family-Medium);
                            }
                            .popup-text {
                                font-family: var(--font-family-Medium);
                                color: #919191;
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
}
